import React from 'react';
import CareerGuidance2023 from 'views/CareerGuidance2023';

const LifeSkillPage = () => {
  return <CareerGuidance2023/>;
};

export default LifeSkillPage;